import { http } from "../http/Http";
import { VolumeUnit } from "../models/VolumeUnit";
import { ServiceResponse } from "../models/ServiceResponse";

export class VolumeUnitService {

    getVolumeUnits = async (): Promise<ServiceResponse<VolumeUnit[]>> => {
        const { data } = await http.get<ServiceResponse<VolumeUnit[]>>("VolumeUnit/GetAll");
        return data;
    };

}